export const CONVERSATION_PATH = '/ai/chatkit_v2/conversation';

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || '';
}

export async function fetchChatkitConversation() {
  const res = await fetch(CONVERSATION_PATH, {
    headers: { Accept: 'application/json' }
  });
  if (!res.ok) return null;
  return res.json();
}
